import React from 'react';
import { IComponentCollapse } from '../../component';
import Accordion from './Accordion';

interface IAllForAccordion extends IComponentCollapse {}

const AllForAccordion = function(props: IAllForAccordion) {
  const { list } = props;
  return (
    <div className="all-for-accordion">
      {(list || []).map((one, index) => (
        <Accordion title={one.title} key={index} expand={one.expand}>
          {one.children}
        </Accordion>
      ))}
    </div>
  );
};

export default AllForAccordion;
